import { gsap } from 'gsap';
import { Draggable } from 'gsap/Draggable';

gsap.registerPlugin(Draggable);

export function initDraggable(el) {
  console.log('draggable');
  Draggable.create(el, {
    zIndexBoost: false,
    bounds: document.querySelector('#site-content'),
  });
}
